module.exports = __webpack_public_path__ + "vue-dist/img/logo.a0208668.png";